import apiClient from "./apiService";

export const changePassword = async (data) => {
  const response = await apiClient.post("/admin/change-password", data);
  return response.data;
};
